import React from "react";
import { ExternalLink } from "../svgIcons/externalLink";
export const ButtonLink = ({ classes, ...props }) => (React.createElement("div", { className: "button-link-wrapper flex" },
    React.createElement("a", { href: props.href ? props.href : "#", onClick: props.onClick, className: `button-link-wrapper__button-link flex ${classes || ""}`, style: { ...props.style }, ...props },
        React.createElement("span", { className: "flex button-link-wrapper__button-content-container" },
            props.children,
            ExternalLink()))));
